module.exports = __webpack_public_path__ + "img/685B57_BEB1B1_9B99A4_1E1D1D-256px.51661fdb.png";